// apps/web/src/self-service/token-shape.ts — Phase 4 follow-up #2.
//
// The /reservierung/:token route in main.tsx catches every 1..n-char
// segment, including obvious non-tokens like `datum`, `kontakt`, `slot`
// (the wizard's noun/verb variants live in /reservieren/, not
// /reservierung/). The previous behavior interpreted "datum" as the
// raw token, fired `Query.reservationByToken`, and rendered the
// "Link nicht mehr gültig" `tokenInvalid` page — misleading, because
// the guest's real link had not expired; the URL was simply wrong.
//
// This module exports the single source of truth for the token shape.
// Mirrored from apps/api/src/lib/reservation-token.ts:51:
//   raw = crypto.randomBytes(24).toString("base64url")
//   → exactly 32 chars, base64url alphabet
//   → charset [A-Za-z0-9_-] (RFC 4648 §5)

// 32 chars, base64url alphabet — the exact length/shape emitted by
// the server's `generateToken`. Used as a pre-flight gate before
// firing `Query.reservationByToken` so obviously-bogus URLs short-
// circuit to the NotFoundCard without a round-trip + reserve of a
// rate-limit bucket.
export const SELF_SERVICE_TOKEN_SHAPE = /^[A-Za-z0-9_-]{32}$/;

export function isValidSelfServiceToken(s: unknown): s is string {
  return typeof s === "string" && SELF_SERVICE_TOKEN_SHAPE.test(s);
}
